import React from "react";

// A utility that takes any number of refs (object refs or callback refs)
// and returns a single ref callback that fans the element out to each.
export function mergeRefs<T>(
  ...refs: Array<React.Ref<T> | undefined>
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (!ref) return;
      if (typeof ref === "function") {
        ref(value);
      } else {
        // assume it's a MutableRefObject
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}